import React, { Component } from 'react';
import '../../inc/genstyle.css';
import '../iinc/iGlobal';
import RandomNumber from '../../inc/random-number';
import { FormErrors } from '../../inc/error-form';
import IHeader from './ifragmentheader';
import ISidemenu from './ifragmentsidemenu';
import INA from './ifragmentna';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const authKey = global.config.authBearerKey+"##"+global.config.kindcode[48];

class IGCPBudgetsForm extends Component {
  constructor (props) {
    super(props);
    this.state = {
        stTitle: '',
        content_types: '',
        
        // Form fields
        isEdit: false,
        budgetdoc_id: '',
        company_name: '',
        company_domain: '',
        subcompany_name: '',
        selectedCompanyId: '',
        selectedSubsidiaryId: '',
        companyOptions: [],
        subsidiaryOptions: [],
        subsidiaryOptions_all: [],
        budget_currency: 'USD',
        budget_price: '',
        budget_name: '',
        refer_to: '',
        interval_periode: '',
        duration_periode: 'month',
        contract_periode: '',
        start_contract_date: '',
        end_contract_date: '',
        long_periode_before: '',
        interval_periode_before: '',
        contract_periode_before: '',
        start_contract_date_before: '',
        limit_alert_1: '',
        limit_alert_2: '',
        limit_alert_3: '',
        limit_alert_4: '',
        limit_alert_5: '',
        formErrors: {selectedCompanyId: '', selectedSubsidiaryId: '', company_name: '', company_domain: '', subcompany_name: '', budget_currency: '', budget_price: '', budget_name: '', refer_to: '', interval_periode: '', contract_periode: '', start_contract_date: '', limit_alert_1: '', limit_alert_2: '', limit_alert_3: '', limit_alert_4: '', limit_alert_5: ''}, 
        companynameValid: false,
        companydomainValid: false,
        subcompanynameValid: false,
        selectedcompanyidValid: false,
        selectedsubsidiaryidValid: false,
        budgetcurrencyValid: false,
        budgetpriceValid: false,
        budgetnameValid: false,
        refertoValid: false,
        intervalperiodeValid: false,
        contractperiodeValid: false,
        startcontractdateValid: false,
        limitalert1Valid: false,
        limitalert2Valid: false,
        limitalert3Valid: false,
        limitalert4Valid: false,
        limitalert5Valid: false,
    }
    this.loadSubCompany = this.loadSubCompany.bind(this);
    this.cuanCompanyOption = this.cuanCompanyOption.bind(this);
    this.cuanSubCompanyOption = this.cuanSubCompanyOption.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleBack = () => {
    window.location.href = global.config.urlOrigin + '/igcpbudget';
  }

  handleSelect = (e) => {
    const value = e.target.value;
    const inputname = e.target.name;
    
    if(inputname === "selectedCompanyId") { 
        var companyValue = JSON.parse(value);
        
        var result = this.state.subsidiaryOptions_all;
        if(companyValue.company_id !== undefined) {
          result = result.filter((list) =>  {
            return list.company_group_id === companyValue.company_id;
          });
        }
        var companyname = companyValue.company_name; 
        var companydomain = companyValue.company_domain;
        this.setState( prevState => {
            return {  
                ...prevState.selectedCompanyId, selectedCompanyId: value,
                ...prevState.company_name, company_name: companyname,
                ...prevState.company_domain, company_domain: companydomain,
                ...prevState.subsidiaryOptions, subsidiaryOptions: result
            }
          },() => { 
            this.validateField("selectedCompanyId", value);
            this.validateField("company_name", value);
            this.validateField("company_domain", value);

          }
        )
    } else if(inputname === "selectedSubsidiaryId") {  
      var subcompanyValue = JSON.parse(value);
      var subcompanyname = subcompanyValue.subcompany_name; 
      
      this.setState( prevState => {
          return {  
              ...prevState.selectedSubsidiaryId, selectedSubsidiaryId: value,
              ...prevState.subcompany_name, subcompany_name: subcompanyname
              
          }
        },() => { 
          this.validateField("selectedSubsidiaryId", value);
          this.validateField("subcompany_name", value);
        }
      )
    } else {
        this.setState( prevState => {
            return {  
                ...prevState[inputname], [inputname]: value
            }
          },() => { this.validateField(inputname, value)}
        )
    }
  }

  handleInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({[name]: value},
        () => { this.validateField(name, value)});
  }

  handleDate = date => {
    this.setState( prevState => {
        return {  
            ...prevState.start_contract_date, start_contract_date: date
        }
        }, () => { this.validateField('start_contract_date', date)
    }) 
  }

  validateField(fieldName, value) {
    let fieldValidationErrors = this.state.formErrors;
    let companynameValid = this.state.companynameValid;
    let companydomainValid = this.state.companydomainValid;
    let subcompanynameValid = this.state.subcompanynameValid;
    let selectedcompanyidValid = this.state.selectedcompanyidValid;
    let selectedsubsidiaryidValid = this.state.selectedsubsidiaryidValid;
    let budgetcurrencyValid = this.state.budgetcurrencyValid;
    let budgetpriceValid = this.state.budgetpriceValid;
    let budgetnameValid = this.state.budgetnameValid;
    let refertoValid = this.state.refertoValid;
    let intervalperiodeValid = this.state.intervalperiodeValid;
    let contractperiodeValid = this.state.contractperiodeValid;
    let startcontractdateValid = this.state.startcontractdateValid;
    let limitalert1Valid = this.state.limitalert1Valid;
    let limitalert2Valid = this.state.limitalert2Valid;
    let limitalert3Valid = this.state.limitalert3Valid;
    let limitalert4Valid = this.state.limitalert4Valid;
    let limitalert5Valid = this.state.limitalert5Valid;

    

    switch(fieldName) {
        case 'company_name': 
            companynameValid = value.trim().length > 0;
            fieldValidationErrors.company_name = companynameValid ? '' : 'company name need to be filled';
            break;
        case 'company_domain': 
            companydomainValid = value.trim().length > 0;
            fieldValidationErrors.company_domain = companydomainValid ? '' : 'company domain need to be filled';
            break;
        case 'subcompany_name': 
          if(this.state.selectedSubsidiaryId !== "" && JSON.parse(this.state.selectedSubsidiaryId).subcompany_id !== undefined) {
            subcompanynameValid = value.trim().length > 0;
            fieldValidationErrors.subcompany_name = subcompanynameValid ? '' : 'subsidiary need to be filled';
          }
            break;
        case 'selectedCompanyId': 
            selectedcompanyidValid = value.trim().length > 0;
            fieldValidationErrors.selectedCompanyId = selectedcompanyidValid ? '' : 'company from cuan-cuan need to be selected';
            break;
        case 'selectedSubsidiaryId': 
            selectedsubsidiaryidValid = value.trim().length > 0;
            fieldValidationErrors.selectedSubsidiaryId = selectedsubsidiaryidValid ? '' : 'subsidiary from cuan-cuan need to be selected';
            break;
        case 'budget_currency': 
            budgetcurrencyValid = value.trim().length > 0;
            fieldValidationErrors.budget_currency = budgetcurrencyValid ? '' : 'currency need to be filled';
            break;
        case 'budget_price': 
            budgetpriceValid = value.trim().length > 0;
            fieldValidationErrors.budget_price = budgetpriceValid ? '' : 'budget need to be filled';
            break;
        case 'budget_name': 
            budgetnameValid = value.trim().length > 0;
            fieldValidationErrors.budget_name = budgetnameValid ? '' : 'budget name need to be filled';
            break;
        case 'refer_to': 
            refertoValid = value.trim().length > 0;
            fieldValidationErrors.refer_to = refertoValid ? '' : 'refer to need to be filled';
            break;
        case 'interval_periode': 
            intervalperiodeValid = value.trim().length > 0;
            fieldValidationErrors.interval_periode = intervalperiodeValid ? '' : 'period need to be filled';
            break;
        case 'contract_periode': 
            contractperiodeValid = value.trim().length > 0;
            fieldValidationErrors.contract_periode = contractperiodeValid ? '' : 'contract period need to be filled';
            break;
        case 'start_contract_date':
            startcontractdateValid = value !== null && value !== ""; 
            fieldValidationErrors.start_contract_date = startcontractdateValid ? '' : 'start contract date need to be filled';
            break;
        case 'limit_alert_1': 
            limitalert1Valid = value.trim().length > 0;
            fieldValidationErrors.limit_alert_1 = limitalert1Valid ? '' : 'first threshold need to be filled';
            break;
        case 'limit_alert_2': 
            limitalert2Valid = value.trim().length > 0;
            fieldValidationErrors.limit_alert_2 = limitalert2Valid ? '' : 'second threshold need to be filled';
            break;
        case 'limit_alert_3': 
            limitalert3Valid = value.trim().length > 0;
            fieldValidationErrors.limit_alert_3 = limitalert3Valid ? '' : 'third threshold need to be filled';
            break;
        case 'limit_alert_4': 
            limitalert4Valid = value.trim().length > 0;
            fieldValidationErrors.limit_alert_4 = limitalert4Valid ? '' : 'fourth threshold need to be filled';
            break;
        case 'limit_alert_5': 
            limitalert5Valid = value.trim().length > 0;
            fieldValidationErrors.limit_alert_5 = limitalert5Valid ? '' : 'fifth threshold need to be filled';
            break;
        default:
            break;
    }
    this.setState({formErrors: fieldValidationErrors,
                    companynameValid: companynameValid,
                    companydomainValid: companydomainValid,
                    subcompanynameValid: subcompanynameValid,
                    selectedcompanyidValid: selectedcompanyidValid,
                    selectedsubsidiaryidValid: selectedsubsidiaryidValid,
                    budgetcurrencyValid: budgetcurrencyValid,
                    budgetpriceValid: budgetpriceValid,
                    budgetnameValid: budgetnameValid,
                    refertoValid: refertoValid,
                    intervalperiodeValid: intervalperiodeValid,
                    contractperiodeValid: contractperiodeValid,
                    startcontractdateValid: startcontractdateValid,
                    limitalert1Valid: limitalert1Valid,
                    limitalert2Valid: limitalert2Valid,
                    limitalert3Valid: limitalert3Valid,
                    limitalert4Valid: limitalert4Valid,
                    limitalert5Valid: limitalert5Valid,
                }, this.validateForm);
  }
  validateForm() {
    this.setState({formValid: 
      this.state.companynameValid && this.state.companydomainValid && this.state.subcompanynameValid  && this.state.selectedcompanyidValid && this.state.selectedsubsidiaryidValid
      && this.state.budgetcurrencyValid && this.state.budgetpriceValid && this.state.budgetnameValid && this.state.refertoValid && this.state.intervalperiodeValid 
      && this.state.contractperiodeValid && this.state.startcontractdateValid && this.state.limitalert1Valid && this.state.limitalert2Valid && this.state.limitalert3Valid 
      && this.state.limitalert4Valid  && this.state.limitalert5Valid
    });
  }

  errorClass(error) {
    return(error.length === 0 ? '' : 'has-error');
  }
  handleSubmit(e) {
    e.preventDefault();
    if(this.state.selectedCompanyId !== "" && this.state.company_name !== "" && this.state.budget_currency !== "" && this.state.budget_price !== "" && this.state.budget_name !== "" && this.state.refer_to !== "" && this.state.interval_periode !== "" && this.state.contract_periode !== "" && this.state.limit_alert_1 !== "" 
        && this.state.start_contract_date !== "" && this.state.start_contract_date !== null
      ) {
        document.getElementById('loading-area').style.display = 'block'; 
        var cuan_company={}, cuan_subcompany={};
        var selectedCompanyId,selectedSubsidiaryId,company_name,company_domain,subcompany_name,budget_currency,budget_price,budget_name,refer_to,interval_periode,contract_periode,long_periode,limit_alert_1,limit_alert_2,limit_alert_3,limit_alert_4,limit_alert_5;
        if(this.textInputCompany.value === '') { selectedCompanyId = this.state.selectedCompanyId; } else { selectedCompanyId = this.textInputCompany.value; }
        if(this.textInputSubsidiary.value === '') { selectedSubsidiaryId = this.state.selectedSubsidiaryId; } else { selectedSubsidiaryId = this.textInputSubsidiary.value; }

        if(this.textInputCompanyName.value === '') { company_name = this.state.company_name; } else { company_name = this.textInputCompanyName.value; }
        if(this.textInputCompanyDomain.value === '') { company_domain = this.state.company_domain; } else { company_domain = this.textInputCompanyDomain.value; }
        if(this.textInputSubcompanyName.value === '') { subcompany_name = this.state.subcompany_name; } else { subcompany_name = this.textInputSubcompanyName.value; }

        if(this.textInputBudgetName.value === '') { budget_name = this.state.budget_name; } else { budget_name = this.textInputBudgetName.value; }
        if(this.textInputBudgetCurrency.value === '') { budget_currency = this.state.budget_currency; } else { budget_currency = this.textInputBudgetCurrency.value; }
        if(this.textInputBudgetPrice.value === '') { budget_price = this.state.budget_price; } else { budget_price = this.textInputBudgetPrice.value; }
        if(this.textInputReferTo.value === '') { refer_to = this.state.refer_to; } else { refer_to = this.textInputReferTo.value; }
        if(this.textInputIntervalPeriode.value === '') { interval_periode = this.state.interval_periode; } else { interval_periode = this.textInputIntervalPeriode.value; }
        if(this.textInputContractPeriode.value === '') { contract_periode = this.state.contract_periode; } else { contract_periode = this.textInputContractPeriode.value; }
        if(this.textInputBudgetLimit1.value === '') { limit_alert_1 = this.state.limit_alert_1; } else { limit_alert_1 = this.textInputBudgetLimit1.value; }
        if(this.textInputBudgetLimit2.value === '') { limit_alert_2 = this.state.limit_alert_2; } else { limit_alert_2 = this.textInputBudgetLimit2.value; }
        if(this.textInputBudgetLimit3.value === '') { limit_alert_3 = this.state.limit_alert_3; } else { limit_alert_3 = this.textInputBudgetLimit3.value; }
        if(this.textInputBudgetLimit4.value === '') { limit_alert_4 = this.state.limit_alert_4; } else { limit_alert_4 = this.textInputBudgetLimit4.value; }
        if(this.textInputBudgetLimit5.value === '') { limit_alert_5 = this.state.limit_alert_5; } else { limit_alert_5 = this.textInputBudgetLimit5.value; }
        
        if(selectedCompanyId !== null && selectedCompanyId !== undefined && selectedCompanyId !== "") { cuan_company = JSON.parse(selectedCompanyId); }
        if(selectedSubsidiaryId !== null && selectedSubsidiaryId !== undefined && selectedSubsidiaryId !== "") { cuan_subcompany = JSON.parse(selectedSubsidiaryId); }
        
        if(interval_periode === "monthly") { long_periode = 1; }
        else if(interval_periode === "bimonthly") { long_periode = 2; }
        else if(interval_periode === "quarterly") { long_periode = 3; }
        else if(interval_periode === "trimesterly") { long_periode = 4; }
        else if(interval_periode === "semianually") { long_periode = 6; }
        else if(interval_periode === "annualy") { long_periode = 12; }

        var startDateLocal = this.state.start_contract_date ? new Date(this.state.start_contract_date) : null;
        var months = parseInt(contract_periode || '0', 10);
        var nextStartLocal = (startDateLocal && months)
          ? new Date(startDateLocal.getFullYear(), startDateLocal.getMonth() + months, startDateLocal.getDate())
          : null;
        var endDateLocal = nextStartLocal ? new Date(nextStartLocal.getTime() - 24 * 60 * 60 * 1000) : null;
        var startDateUtc = startDateLocal
          ? new Date(Date.UTC(startDateLocal.getFullYear(), startDateLocal.getMonth(), startDateLocal.getDate(), 0, 0, 0, 0))
          : null;
        var endDateUtc = endDateLocal
          ? new Date(Date.UTC(endDateLocal.getFullYear(), endDateLocal.getMonth(), endDateLocal.getDate(), 0, 0, 0, 0))
          : null;
          
        var data = {
          budget_keyid: RandomNumber(10001,99999),
          budget_name: budget_name,
          budget_currency: budget_currency,
          budget_price: budget_price,
          refer_to: refer_to,
          duration_periode: this.state.duration_periode,
          interval_periode: interval_periode,
          contract_periode: contract_periode,
          long_periode: long_periode,
          limit_alert_1: (limit_alert_1 !== "" && limit_alert_1 !== null)? parseFloat(limit_alert_1/100).toFixed(2) : limit_alert_1,
          limit_alert_2: (limit_alert_2 !== "" && limit_alert_2 !== null)? parseFloat(limit_alert_2/100).toFixed(2) : limit_alert_2,
          limit_alert_3: (limit_alert_3 !== "" && limit_alert_3 !== null)? parseFloat(limit_alert_3/100).toFixed(2) : limit_alert_3,
          limit_alert_4: (limit_alert_4 !== "" && limit_alert_4 !== null)? parseFloat(limit_alert_4/100).toFixed(2) : limit_alert_4,
          limit_alert_5: (limit_alert_5 !== "" && limit_alert_5 !== null)? parseFloat(limit_alert_5/100).toFixed(2) : limit_alert_5,
          company_name: company_name,
          company_domain: company_domain,
          subcompany_name: subcompany_name,
          start_contract_date: startDateUtc ? startDateUtc.toISOString() : null,
          end_contract_date: endDateUtc ? endDateUtc.toISOString() : null,

          cuan_company_domain: cuan_company.company_domain,
          cuan_company_id: cuan_company.company_id,
          cuan_company_name: cuan_company.company_name,
          cuan_subcompany_id: cuan_subcompany.subcompany_id !== undefined? cuan_subcompany.subcompany_id : '',
          cuan_subcompany_name: cuan_subcompany.subcompany_name !== undefined? cuan_subcompany.subcompany_name : ''
        }

        var urlFetch;
        if(this.state.content_types === "edit" && this.state.budgetdoc_id !== "") {
            data.long_periode_bf = this.state.long_periode_before;
            data.interval_periode_bf = this.state.interval_periode_before;
            data.contract_periode_bf = this.state.contract_periode_before;
            data.start_contract_date_bf = this.state.start_contract_date_before;

            data.budget_docid = this.state.budgetdoc_id;
            data.form_id = "form-edit";
            urlFetch = global.config.urlLink+"/gcpbudgetedit";
        } else {
            data.form_id = "form-add";
            urlFetch = global.config.urlLink+"/gcpbudgetadd";
        }
        fetch(urlFetch, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': authKey,
            }, body : JSON.stringify(data)
          }).then(res => {
            if(res.status === 200) 
                return res.json() 
          }).then( resJson => {
            document.getElementById('loading-area').style.display = 'none'; 
            if(resJson.status === '200') {
                var resultid = resJson.values;
                window.location.href='/iviewgcpbudget/'+resultid;
            } else {
                console.log('Something happened wrong');
            }
          }).catch(err => { 
            document.getElementById('loading-area').style.display = 'none'; 
            console.log(err);
          });

    } else {
        var arrfieldName = ['selectedCompanyId','company_name','budget_currency','budget_price','budget_name','refer_to','interval_periode','contract_periode','limit_alert_1','start_contract_date'];
        var arrvalue = [this.state.selectedCompanyId,this.textInputCompanyName.value,this.textInputBudgetCurrency.value,this.textInputBudgetPrice.value,this.textInputBudgetName.value,this.textInputReferTo.value,this.textInputIntervalPeriode.value,this.textInputContractPeriode.value,this.textInputBudgetLimit1.value,this.state.start_contract_date];
        for(var ck in arrfieldName) {
            this.validateField(arrfieldName[ck], arrvalue[ck]);
        }
    }
  }
  cuanSubCompanyOption = (dataSubCompany) => {
    var selsubcompanyList = [];
    if(dataSubCompany.length > 0) {
        for(var s in dataSubCompany) {
          var subcompany_data = {
            subcompany_id: dataSubCompany[s].subsidiary_id, 
            subcompany_name: dataSubCompany[s].subsidiary_name, 
            subcompany_legal_name: dataSubCompany[s].subsidiary_legal,
          }
          selsubcompanyList.push(<option value={JSON.stringify(subcompany_data)} key={"S"+s}>{dataSubCompany[s].subsidiary_name}</option>)
        }
    }
    return [selsubcompanyList];
  }
  cuanCompanyOption = (dataCompany) => {
    var selcompanyList = [];
    if(dataCompany.length > 0) {
        for(var c in dataCompany) {
          var company_data = {
            company_id: dataCompany[c].company_group_id, 
            company_name: dataCompany[c].company_group_name, 
            company_domain: dataCompany[c].company_group_domain,
            company_legal_name: dataCompany[c].company_group_legal,
          }
          selcompanyList.push(<option value={JSON.stringify(company_data)} key={"C"+c}>{dataCompany[c].company_group_name}</option>)
        }
    }
    return [selcompanyList];
  }

  getCuanCompany = () => {
    return new Promise((resolve) => {
      fetch(global.config.urlCuan2+"/get/company_groups", {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      }).then(response => {
        if(response.status === 200) {
          return response.json();
        } else {
          console.log('Something happened wrong');
        }
      }).then(resultJson => {
        if(resultJson.status === 200) { 
          resolve(resultJson.data);
        } else {
          resolve([]);
        }
      });
    });
  }
  getCuanSubCompany = () => {
    return new Promise((resolve) => {
      var urlfetch = global.config.urlCuan2+"/get/subsidiaries";
      fetch(urlfetch, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      }).then(response => {
        if(response.status === 200) {
          return response.json();
        } else {
          console.log('Something happened wrong');
        }
      }).then(resultJson => {
        if(resultJson.status === 200) { 
          resolve(resultJson.data);
        } else {
          resolve([]);
        }
      });
    });
  }
  getBudgetDetail = (id) => {
    return new Promise((resolve) => {
      var urlfetch = global.config.urlCuan2+"/get/subsidiaries";
      fetch(global.config.urlLink+"/gcpbudgetview/"+id, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': authKey,
        }
      }).then(res => {
        if(res.status === 200) 
            return res.json() 
      }).then( resJson => {
        if(resJson.status === "200") { 
          resolve(resJson.values[0]);
        } else {
          resolve([]);
        }
      });
    });
  }
  loadSubCompany(companyid) {
    if(companyid !== "" && companyid !== null && companyid !== undefined) {

      var subcompanyList = this.state.subsidiaryOptions_all.filter((list) => {
        return list.company_group_id === companyid
      })

      this.setState({
        subsidiaryOptions: subcompanyList,
      });
    }
  }
  async loadData(element,id) {
    document.getElementById('loading-area').style.display = 'block';         
    if(element.toLowerCase() === "ieditgcpbudget") {
      const [result1,result2,result3] = await Promise.all([this.getCuanCompany(),this.getCuanSubCompany(),this.getBudgetDetail(id)]);
      if(result1 && result2  && result3) {
        var resultDetail = result3.content[0];
        var option_value_company = result1.sort((a, b) => a.company_group_name.localeCompare(b.company_group_name));
        var option_value_subcompany_all = result2.sort((a, b) => a.subsidiary_name.localeCompare(b.subsidiary_name));
        var option_value_subcompany = option_value_subcompany_all;
        var company_data = {}, subcompany_data = {};
        
        if(resultDetail.cuan_companyId !== undefined && resultDetail.cuan_companyId !== "") {
          var resultcompany = result1.filter((list) =>  {
            return (list.company_group_id = resultDetail.cuan_companyId);
          });
          if(resultcompany.length > 0) {
            company_data = {
              company_id: resultcompany[0].company_group_id, 
              company_name: resultcompany[0].company_group_name, 
              company_domain: resultcompany[0].company_group_domain,
              company_legal_name: resultcompany[0].company_group_legal,
            }
          }
          option_value_subcompany = result2.filter((list2) =>  {
            return list2.company_group_id === resultDetail.cuan_companyId;
          });
          
        }
        if(resultDetail.cuan_subcompanyId !== undefined && resultDetail.cuan_subcompanyId !== null && resultDetail.cuan_subcompanyId !== "") {
          var resultsubcompany = result2.filter((list3) =>  {
            return (list3.subsidiary_id.toString() === resultDetail.cuan_subcompanyId.toString());
          });
          if(resultsubcompany.length > 0) {
            subcompany_data = {
              subcompany_id: resultsubcompany[0].subsidiary_id, 
              subcompany_name: resultsubcompany[0].subsidiary_name, 
              subcompany_legal_name: resultsubcompany[0].subsidiary_legal,
            }
          }
        }
        
        this.setState({
          activelink: element.toLowerCase(),
          stTitle: 'Edit Budget',
          content_types: 'edit',
          
          // Form fields
          isEdit: true,
          budgetdoc_id: resultDetail.budget_doc_id,
          company_name: resultDetail.company_name,
          company_domain: resultDetail.company_domain,
          subcompany_name: resultDetail.subcompany_name,
          selectedCompanyId: JSON.stringify(company_data),
          selectedSubsidiaryId: JSON.stringify(subcompany_data),
          companyOptions: option_value_company, 
          subsidiaryOptions: option_value_subcompany,
          subsidiaryOptions_all: option_value_subcompany_all,
          budget_currency: resultDetail.currency,
          budget_price: resultDetail.budget,
          budget_name: resultDetail.budget_name !== null?resultDetail.budget_name : '',
          refer_to: resultDetail.refer_to,
          interval_periode: resultDetail.interval_periode,
          duration_periode: resultDetail.duration_periode,
          contract_periode: resultDetail.contract_periode,
          start_contract_date: resultDetail.start_contract_periode !== null? new Date(resultDetail.start_contract_periode.value.split("T")[0]) : new Date(),
          end_contract_date: resultDetail.end_contract_periode !== null? new Date(resultDetail.end_contract_periode.value.split("T")[0]) : new Date(),
          limit_alert_1: resultDetail.limit_alert_1 > 0? resultDetail.limit_alert_1*100 : '',
          limit_alert_2: resultDetail.limit_alert_2 > 0? resultDetail.limit_alert_2*100 : '',
          limit_alert_3: resultDetail.limit_alert_3 > 0? resultDetail.limit_alert_3*100 : '',
          limit_alert_4: resultDetail.limit_alert_4 > 0? resultDetail.limit_alert_4*100 : '',
          limit_alert_5: resultDetail.limit_alert_5 > 0? resultDetail.limit_alert_5*100 : '',

          long_periode_before: resultDetail.long_periode,
          interval_periode_before: resultDetail.interval_periode,
          contract_periode_before: resultDetail.contract_periode,
          start_contract_date_before: resultDetail.start_contract_periode !== null? new Date(resultDetail.start_contract_periode.value.split("T")[0]) : new Date(),
        });
        document.getElementById('loading-area').style.display = 'none'; 
        
      }

    } else if(element.toLowerCase() === "iaddgcpbudget") {
      const [result1,result2] = await Promise.all([this.getCuanCompany(),this.getCuanSubCompany()]);
      if(result1 && result2) {
        this.setState({
          activelink: element.toLowerCase(),
          stTitle: 'New Budget',
          content_types: 'add',
          companyOptions: result1.sort((a, b) => a.company_group_name.localeCompare(b.company_group_name)), 
          subsidiaryOptions: result2.sort((a, b) => a.subsidiary_name.localeCompare(b.subsidiary_name)),
          subsidiaryOptions_all: result2.sort((a, b) => a.subsidiary_name.localeCompare(b.subsidiary_name)),
        });
        document.getElementById('loading-area').style.display = 'none'; 
        
      }

    } else {
      document.getElementById('loading-area').style.display = 'none'; 
      window.location.href='/igcpbudget';
    }
  }
  componentDidMount() {
    var arrString = window.location.pathname; 
    var arrUrl = [];
    arrUrl = arrString.split('/');
    this.loadData(arrUrl[1],arrUrl[2]);

  }
  

 render() {
   return (
    <div className="main-container">
      <div  className="header-main"><IHeader/></div>
          <div className="flex-container">
              <div className="sidebar-main"><ISidemenu/></div>
              <div className="main-content">
                <div className="stTitle">Client's Budget GCP</div>
                {((localStorage.getItem('ulevel') === global.config.userlevel[0]) || (JSON.parse(localStorage.getItem('urole'))[9] === "ON"))? 
              <div>
                <div className="stIndiTitle">Client's Google Cloud Platform Billing Budget { this.state.stTitle !== ''? '> '+this.state.stTitle : '' } </div>
                <div className="mgT30">
                    {/* ====== */}
                    <div  className="content-container card card-body">
                        <div className="flex-container">
                            <div className="st2Title w70p">{ this.state.stTitle.includes("New")? '' : '' } {this.state.stTitle}</div>
                            <div className="divRight w30p"><div><button className="backButton" onClick={this.handleBack}>&#9664; back</button></div></div>
                        </div>
                        <div id="FormCenter" className="mgT20">
                            <div id="FormAddContentInfo">
                                {/* PUT FORM IN HERE */}
                                <form onSubmit={this.handleSubmit}>
                                    <div className="row-field mgT20 border p-2">
                                      <div className='textBold'>Select Company from Cuan-cuan</div>
                                      <div className="d-flex mgT20">
                                          <label className="labelFormL" htmlFor="selectedCompanyId">Company Name</label>
                                          <div className="w60p">
                                              <select name="selectedCompanyId" className="form-control"
                                                  value={this.state.selectedCompanyId}
                                                  onChange={this.handleSelect}
                                                  ref={(input) => this.textInputCompany = input}
                                                >
                                                  <option value="{}">-- Select Company --</option>
                                                  {this.cuanCompanyOption(this.state.companyOptions)}
                                                  
                                              </select>
                                              <div className="mgT05">{ <FormErrors formErrors={this.state.formErrors.selectedCompanyId}/>  }</div>
                                          </div>
                                      </div>
                                      <div className="d-flex mgT20">
                                          <label className="labelFormL" htmlFor="selectedSubsidiaryId">Subsidiary Company </label>
                                          <div className="w60p">
                                            <select name="selectedSubsidiaryId" className="form-control"
                                                value={this.state.selectedSubsidiaryId}
                                                onChange={this.handleSelect}
                                                ref={(input) => this.textInputSubsidiary = input}
                                              >
                                                <option value="{}">-- Select Subcompany --</option>
                                                {this.cuanSubCompanyOption(this.state.subsidiaryOptions)}
                                               
                                              </select>
                                              <div className="mgT05">{ <FormErrors formErrors={this.state.formErrors.selectedSubsidiaryId}/>  }</div>
                                          </div>
                                      </div>
                                    </div>
                                    <div className="p-2">
                                      <div className="row-field mgT20">
                                          <label className="labelFormL" htmlFor="company_name">Company Name</label>
                                          <div className="w60p">
                                              <input type="text" className="form-control" name="company_name"
                                                  placeholder="Enter company name"
                                                  value={this.state.company_name}
                                                  onChange={this.handleInput} 
                                                  ref={(input) => this.textInputCompanyName = input}
                                                  />
                                              <div className="mgT05">{ <FormErrors formErrors={this.state.formErrors.company_name}/>  }</div>
                                          </div>
                                      </div>
                                      <div className="row-field mgT20">
                                          <label className="labelFormL" htmlFor="company_domain">Company Domain</label>
                                          <div className="w60p">
                                              <input type="text" className="form-control" name="company_domain"
                                                  placeholder="Enter company domain"
                                                  value={this.state.company_domain}
                                                  onChange={this.handleInput} 
                                                  ref={(input) => this.textInputCompanyDomain = input}
                                                  />
                                              <div className="mgT05">{ <FormErrors formErrors={this.state.formErrors.company_domain}/>  }</div>
                                          </div>
                                      </div>
                                      <div className="row-field mgT20">
                                          <label className="labelFormL" htmlFor="subcompany_name">Subsidiary Company Name</label>
                                          <div className="w60p">
                                              <input type="text" className="form-control" name="subcompany_name"
                                                  placeholder="Enter subcompany name"
                                                  value={this.state.subcompany_name}
                                                  onChange={this.handleInput} 
                                                  ref={(input) => this.textInputSubcompanyName = input}
                                                  />
                                              <div className="mgT05">{ <FormErrors formErrors={this.state.formErrors.subcompany_name}/>  }</div>
                                          </div>
                                      </div>
                                      <div className="row-field mgT50">
                                          <label className="labelFormL" htmlFor="budget_name">Budget Name</label>
                                          <div className="w60p">
                                              <input type="text" className="form-control" name="budget_name"
                                                  placeholder="Enter budget name"
                                                  value={this.state.budget_name}
                                                  onChange={this.handleInput} 
                                                  ref={(input) => this.textInputBudgetName = input}
                                                  />
                                              <div className="mgT05">{ <FormErrors formErrors={this.state.formErrors.budget_name}/>  }</div>
                                          </div>
                                      </div>
                                      <div className="row-field mgT20">
                                          <label className="labelFormL" htmlFor="refer_to">Refer To</label>
                                          <div className="w30p">
                                              <select name="refer_to" className="form-control"
                                                  value={this.state.refer_to}
                                                  onChange={this.handleSelect}
                                                  ref={(input) => this.textInputReferTo = input}
                                              >
                                                  <option value="">-- Select reference --</option>
                                                  { global.config.gcpbudgetReference.map((rf) => {
                                                      return (<option value={rf.value}>{rf.label}</option>)
                                                    })
                                                  }
                                              </select>
                                              <div className="mgT05">{ <FormErrors formErrors={this.state.formErrors.refer_to}/>  }</div>
                                          </div>
                                      </div>
                                      <div className="row-field mgT20">
                                          <label className="labelFormL" htmlFor="budget_price">Budget</label>
                                          <div>
                                              <div className="flex-container">
                                                  <div className="mgR20">
                                                      <select name="budget_currency" className="form-control" 
                                                          value={this.state.budget_currency} 
                                                          onChange={this.handleSelect}
                                                          ref={(input) => this.textInputBudgetCurrency = input}
                                                      >
                                                          <option value="USD">USD</option>
                                                          <option value="SGD">SGD</option>
                                                          <option value="IDR">IDR</option>
                                                          <option value="MYR">MYR</option>
                                                      </select>
                                                  </div>
                                                  <div>
                                                      <input type="number" className="form-control" name="budget_price"
                                                          placeholder="Budget amount"
                                                          value={this.state.budget_price}
                                                          ref={(input) => this.textInputBudgetPrice = input}
                                                          onChange={this.handleInput}  /> 
                                                  </div>
                                              </div>
                                              <div className="mgT05">{ <FormErrors formErrors={this.state.formErrors.budget_price}/>  }</div>
                                          </div>
                                      </div>
                                      <div className="row-field mgT20">
                                          <label className="labelFormL" htmlFor="interval_periode">For Periode</label>
                                          <div className="w30p">
                                              <select name="interval_periode" className="form-control" 
                                                  value={this.state.interval_periode}
                                                  onChange={this.handleSelect}
                                                  ref={(input) => this.textInputIntervalPeriode = input}
                                              >
                                              <option value="" key="">-- please select --</option>
                                              <option value="monthly">monthly</option>
                                              <option value="bimonthly">bimonthly</option>
                                              <option value="quarterly">quarterly</option>
                                              <option value="trimesterly">trimesterly</option>
                                              <option value="semianually">semianually</option>
                                              <option value="annualy">annualy</option>
                                              </select>
                                              <div className="mgT05">{ <FormErrors formErrors={this.state.formErrors.interval_periode}/>  }</div>
                                          </div>
                                      </div>
                                      <div className="row-field mgT20">
                                          <label className="labelFormL" htmlFor="contract_periode">Contract Periode</label>
                                          <div className="w60p">
                                              <div className="flex-container">
                                                  <div>
                                                    <input type="number" className="form-control" name="contract_periode"
                                                        value={this.state.contract_periode}
                                                        onChange={this.handleInput}
                                                        ref={(input) => this.textInputContractPeriode = input}
                                                        placeholder="Contract months"
                                                    />
                                                    <div className="mgT05">{ <FormErrors formErrors={this.state.formErrors.contract_periode}/>  }</div>
                                                  </div>
                                                  <div className="mgL20">month(s)</div>
                                              </div>
                                              
                                          </div>
                                      </div>
                                      <div className="row-field mgT20">
                                          <label className="labelFormL" htmlFor="start_contract_date">Start Contract Date</label>
                                          <div>
                                              <DatePicker
                                                  onChange={this.handleDate}
                                                  value={this.state.start_contract_date}
                                                  selected={this.state.start_contract_date}
                                                  dateFormat="dd MMM yyyy"
                                                  className="form-control"
                                                  />

                                              <div className="mgT05">{ <FormErrors formErrors={this.state.formErrors.start_contract_date}/>  }</div>
                                          </div>
                                      </div>
                                      <div className="row-field mgT20">
                                          <label className="labelFormL" htmlFor="limit_alert_1">Threshold 1</label>
                                          <div className="w60p">
                                              <div className="flex-container">
                                                  <div>
                                                      <input type="number" className="form-control" name="limit_alert_1"
                                                          value={this.state.limit_alert_1}
                                                          onChange={this.handleInput}
                                                          ref={(input) => this.textInputBudgetLimit1 = input}
                                                          placeholder="e.g., 50" />
                                                      <div className="mgT05">{ <FormErrors formErrors={this.state.formErrors.limit_alert_1}/>  }</div>
                                                  </div>
                                                  <div className="mgL20">%</div>
                                              </div>
                                              
                                          </div>
                                      </div>
                                      <div className="row-field mgT20">
                                          <label className="labelFormL" htmlFor="limit_alert_2">Threshold 2</label>
                                          <div className="w60p">
                                              <div className="flex-container">
                                                  <div>
                                                      <input type="number" className="form-control" name="limit_alert_2"
                                                          value={this.state.limit_alert_2}
                                                          onChange={this.handleInput}
                                                          ref={(input) => this.textInputBudgetLimit2 = input}
                                                          placeholder="e.g., 80" />
                                                      <div className="mgT05">{ <FormErrors formErrors={this.state.formErrors.limit_alert_2}/>  }</div>
                                                  </div>
                                                  <div className="mgL20">%</div>
                                              </div>
                                              
                                          </div>
                                      </div>
                                      <div className="row-field mgT20">
                                          <label className="labelFormL" htmlFor="limit_alert_3">Threshold 3</label>
                                          <div className="w60p">
                                              <div className="flex-container">
                                                  <div>
                                                      <input type="number" className="form-control" name="limit_alert_3"
                                                          value={this.state.limit_alert_3}
                                                          onChange={this.handleInput}
                                                          ref={(input) => this.textInputBudgetLimit3 = input}
                                                          placeholder="e.g., 90" />
                                                      <div className="mgT05">{ <FormErrors formErrors={this.state.formErrors.limit_alert_3}/>  }</div>
                                                  </div>
                                                  <div className="mgL20">%</div>
                                              </div>
                                          </div>
                                      </div>
                                      <div className="row-field mgT20">
                                          <label className="labelFormL" htmlFor="limit_alert_4">Threshold 4</label>
                                          <div className="w60p">
                                              <div className="flex-container">
                                                  <div>
                                                      <input type="number" className="form-control" name="limit_alert_4"
                                                          value={this.state.limit_alert_4}
                                                          onChange={this.handleInput}
                                                          ref={(input) => this.textInputBudgetLimit4 = input}
                                                          placeholder="e.g., 95" />
                                                      <div className="mgT05">{ <FormErrors formErrors={this.state.formErrors.limit_alert_4}/>  }</div>
                                                  </div>
                                                  <div className="mgL20">%</div>
                                              </div>
                                          </div>
                                      </div>
                                      <div className="row-field mgT20">
                                          <label className="labelFormL" htmlFor="limit_alert_5">Threshold 5</label>
                                          <div className="w60p">
                                              <div className="flex-container">
                                                  <div>
                                                      <input type="number" className="form-control" name="limit_alert_5"
                                                          value={this.state.limit_alert_5}
                                                          onChange={this.handleInput}
                                                          ref={(input) => this.textInputBudgetLimit5 = input}
                                                          placeholder="e.g., 100" />
                                                      <div className="mgT05">{ <FormErrors formErrors={this.state.formErrors.limit_alert_5}/>  }</div>
                                                  </div>
                                                  <div className="mgL20">%</div>
                                              </div>
                                          </div>
                                      </div>
                                      <div className="row-field mgT30 mgB30">
                                          <div className="labelFormL"></div>
                                          <div className="w60p"><button type="submit" className="w100p submitButton">Submit</button></div>
                                      </div>
                                    </div>
                                </form>
                            </div>
                           
                        </div>
                    </div>
                    {/* ====== */}
                  </div>  
              </div>
              :   
              <div><INA/></div>
              }
              </div>
          </div>
          <div id="loading-area" className="divHide loading"></div> 
    </div>
   );
 }
}
 
export default IGCPBudgetsForm;
